import React, { useEffect, useState } from "react";

function getApiUrl() { 
  return "https://bitcoin.api.bitcoinagree.com/v1/";
}

export default function App() {
  const [btcPrice, setBtcPrice] = useState(null);
  const [btc, setBtc] = useState(1);
  const [usd, setUsd] = useState(0);

  useEffect(() => {
    document.title = "BitcoinAgree Exchange (React)";
    fetch(getApiUrl())
      .then((res) => res.json())
      .then((data) => {
        setBtcPrice(data.usd);
        setUsd(1 * data.usd);
      });
  }, []);

  const handleBtcChange = (e) => {
    const value = e.target.value;
    setBtc(value);
    if (btcPrice !== null && value !== "") setUsd(parseFloat(value) * btcPrice);
    else setUsd("");
  };

  const handleUsdChange = (e) => {
    const value = e.target.value;
    setUsd(value);
    if (btcPrice !== null && value !== "") setBtc(parseFloat(value) / btcPrice);
    else setBtc("");
  };

  return (
    <div style={{ fontFamily: "Arial", maxWidth: 400, margin: "40px auto" }}>
      <h2>
        <a href="https://bitcoinagree.com" style={{ textDecoration: "underline", color: "inherit" }}>BitcoinAgree</a> Exchange (React)
      </h2>
      <div id="price">
        {btcPrice === null ? "Loading BTC price..." : `1 BTC = $${btcPrice} USD`}
      </div>
      <div className="row" style={{ marginBottom: 16 }}>
        <label htmlFor="btc" style={{ display: "inline-block", width: 60 }}>
          BTC:
        </label>
        <input
          type="number"
          id="btc"
          step="any"
          value={btc}
          onChange={handleBtcChange}
        />
      </div>
      <div className="row" style={{ marginBottom: 16 }}>
        <label htmlFor="usd" style={{ display: "inline-block", width: 60 }}>
          USD:
        </label>
        <input
          type="number"
          id="usd"
          step="any"
          value={usd}
          onChange={handleUsdChange}
        />
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/App.js